import { connect } from 'react-redux';
import { getIsPlaying } from 'store/reducers/player';
import ButtonAnimation from './ButtonAnimation';

const mapStateToProps = (state) => ({
  isPlaying: getIsPlaying(state),
});

export default connect(mapStateToProps)(ButtonAnimation);
